export default __webpack_public_path__ + "static/BPA Tonbridge-d307327db1b7bdd1421053c78ec1fe73.png";